import type { VoidFunctionComponent } from 'react';

import { VCS_APP_DISPLAY } from '../../../../../shared/vcs/githubApp/apps';
import Button from '../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button/button-constants';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

import styles from './VcsInstallPanel.module.less';

/** The install pitch per app: what installing it buys, matching the sidebar's About copy. */
const APP_PITCH: Record<VcsApp, { heading: string; copy: string }> = {
  fossabot: {
    heading: 'Install the fossabot app',
    copy:
      'Grant fossabot access to your GitHub repositories so it can open fix PRs and run breaking ' +
      'change analysis automatically — without leaving FOSSA.',
  },
  fossaCore: {
    heading: 'Install the FOSSA GitHub app',
    copy: 'Grant FOSSA read access to your GitHub repositories so it can import and analyze your projects.',
  },
};

type Props = {
  /** The app the org imports through; the pitch and logo describe this app. */
  app: VcsApp;
  onInstall: () => void;
};

/**
 * The main panel before the app is installed: what installing the active app buys, and the
 * button that starts the vcs-service install. It is replaced by the repository list once installed.
 */
export const VcsInstallPanel: VoidFunctionComponent<Props> = ({ app, onInstall }) => (
  <div className={styles.panel}>
    <img className={styles.logo} src={VCS_APP_DISPLAY[app].logo} alt="" />
    <h1 className={styles.heading}>{APP_PITCH[app].heading}</h1>
    <p className={styles.copy}>{APP_PITCH[app].copy}</p>
    <Button type={BUTTON_TYPE.PRIMARY} size={BUTTON_SIZE.MEDIUM} onClick={onInstall}>
      Install on GitHub
    </Button>
  </div>
);
